<template>
  <section>
    <NewsItem
      class="has-margin-b-2"
      v-for="item in itemdata"
      v-bind:key="item.id"
      :itemdata="item"
      :itemid="item.id"
    />
    <b-pagination
      class="has-margin-t-3"
      :total="total"
      :current.sync="current"
      :range-before="rangeBefore"
      :range-after="rangeAfter"
      :order="order"
      :size="size"
      :simple="isSimple"
      :rounded="isRounded"
      :per-page="perPage"
      :icon-prev="prevIcon"
      :icon-next="nextIcon"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
    </b-pagination>
  </section>
</template>

<script>
import NewsItem from "@/components/NewsItem.vue";
export default {
  name: "NewsList",
  components: {
    NewsItem
  },
  props: {
    itemsData: Array,
    totalItems: Number
  },
  data() {
    return {
      perPage: 5,
      rangeBefore: 3,
      rangeAfter: 1,
      order: "",
      size: "",
      isSimple: false,
      isRounded: false,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right"
    };
  },
  methods: {},
  computed: {
    itemdata: {
      get: function() {
        return this.itemsData;
      }
    },
    total: {
      get: function() {
        return this.totalItems;
      }
    },
    current: {
      get: function() {
        if (this.$route.params.page !== undefined) {
          return Number(this.$route.params.page);
        } else {
          return 1;
        }
      },
      // setter
      set: function(val) {
        // this.currentPage = val;
        //path: `/category/${this.$route.params.cname}/${val}`
        this.$router.push({
          path: `/news/${val}`
        });
      }
    }
  }
};
</script>
<style scoped>
.card-foot {
  justify-content: flex-end; /* space-between flex-end; */
}
.has-border-righ {
  border-right: 1px solid #dbdbdb;
}
.card {
  margin-bottom: 25px;
}
.money {
  padding: 0;
  margin: 0 10px 0 0;
}
.moneycols {
  margin: 0;
  padding: 0 0 10px 0;
}
</style>
